// localization.ts
import i18next, { exists } from 'i18next';
import i18n from './init';
import { useTranslation as useOriginalUseTranslation } from 'react-i18next';

// translate utility object
export const translate = {
	t: (key: string, translationObject?: { [key: string]: string; }) => i18next.t(key, translationObject),
	getResourceBundle: () => i18next.getResourceBundle(i18next.language, 'translation'),
	checkIfTranslateInitialized: () => i18n.isInitialized,
	exists: (key: string) => exists(key),
};

// Change language and load translations
export const setLanguage = async (language: string): Promise<void> => {
	await i18n.changeLanguage(language);
};

// Add translations dynamically
export const addTranslations = (language: string, translations: Record<string, unknown>): void => {
    i18n.addResourceBundle(language, 'translation', translations, true, true);
};

// wrapper hook for `useTranslation`
export const useTranslation = () => {
    const { t } = useOriginalUseTranslation();
    return {t};
};
